import { produce } from 'immer'
import Actions from '../actions'
import dayjs from 'dayjs'
import {
  INACTIVITY_TIMEOUT_IN_SECONDS,
  INACTIVITY_TIMEOUT_WARNING_IN_SECONDS
} from 'consts'
import { LAYOUT_TYPE } from 'consts'

const initialState = {
  isSaveProgressDialogVisible: false,
  saveProgressDialogTimeToOpen: null, // last date time when save progress dialog was opened,
  isSaveProgressSuccess: false,
  appConfig: {
    access_token_lifetime: INACTIVITY_TIMEOUT_IN_SECONDS,
    inactivity_timeout_warning: INACTIVITY_TIMEOUT_WARNING_IN_SECONDS,
    age_limitations: {
      adult: { min: 18 },
      dependent: { min: 0, max: 26 }
    },
    portal_open: true
  },
  shouldShowErrorModal: false,
  shouldShowTimeoutModal: false,
  shouldShowBrokerTimeoutModal: false,
  tokenExpirationTime: null,
  lastUserInteraction: null,
  isLoggingOut: false,
  layout: LAYOUT_TYPE.self_enroll,
  isShareApplicationDialogVisible: false,
  isShareQuoteDialogVisible: false,
  imageToShare: null,
  isSaveRequsted: false,
  locationRoute: null,
  shouldShowUnauthorizedModal: false
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.LOGOUT_REQUESTED: {
      draft.isLoggingOut = true
      break
    }
    case Actions.LOGOUT_RECEIVED: {
      draft.isLoggingOut = false
      break
    }
    case Actions.SAVE_PROGRESS_DIALOG_OPENED: {
      draft.isSaveProgressSuccess = false
      draft.isSaveProgressDialogVisible = true

      // on session it should be open after 30 minutes
      const saveInterval = draft.appConfig?.save_progress_interval || 30
      const saveProgressDialogTimeToOpen = dayjs().add(saveInterval, 'minute')
      draft.saveProgressDialogTimeToOpen = saveProgressDialogTimeToOpen
      // save to local storage
      localStorage.setItem(
        'saveProgressDialogTimeToOpen',
        saveProgressDialogTimeToOpen
      )
      break
    }
    case Actions.SAVE_PROGRESS_DIALOG_CLOSED: {
      draft.isSaveProgressDialogVisible = false
      break
    }
    case Actions.SAVE_PROGRESS_RECEIVED: {
      draft.isSaveProgressSuccess = true
      break
    }
    case Actions.OPERATION_FAILED: {
      draft.shouldShowErrorModal = true
      break
    }
    case Actions.SYSTEM_ERROR_MODAL_CLOSED: {
      draft.shouldShowErrorModal = false
      break
    }
    case Actions.TIMEOUT_MODAL_OPENED: {
      draft.shouldShowTimeoutModal = true
      break
    }
    case Actions.UNAUTHORIZED_MODAL_OPENED: {
      draft.shouldShowUnauthorizedModal = true
      break
    }
    case Actions.TIMEOUT_MODAL_CLOSED: {
      draft.shouldShowTimeoutModal = false
      break
    }
    case Actions.TOKEN_EXPIRY_UPDATED: {
      draft.tokenExpirationTime = payload
      break
    }
    case Actions.USER_INTERACTED: {
      draft.lastUserInteraction = dayjs()
      break
    }
    case Actions.SHARE_APPLICATION_DIALOG_OPENED: {
      draft.isShareApplicationDialogVisible = true
      break
    }
    case Actions.SHARE_APPLICATION_RECEIVED:
    case Actions.SHARE_APPLICATION_DIALOG_CLOSED: {
      draft.isShareApplicationDialogVisible = false
      break
    }
    case Actions.SHARE_QUOTE_DIALOG_OPENED: {
      draft.isShareQuoteDialogVisible = true
      draft.imageToShare = payload.dataUrl
      break
    }
    case Actions.SHARE_QUOTE_RECEIVED:
    case Actions.SHARE_QUOTE_DIALOG_CLOSED: {
      draft.isShareQuoteDialogVisible = false
      draft.imageToShare = null
      break
    }
    case Actions.APP_CONFIG_RECEIVED: {
      draft.appConfig = {
        ...draft.appConfig,
        ...payload.config
      }
      break
    }
    case Actions.LOCATION_CHANGED: {
      draft.locationRoute = payload?.location
      break
    }
    case Actions.BROKER_TIMEOUT_MODAL_OPENED: {
      draft.shouldShowBrokerTimeoutModal = true
      break
    }
    case Actions.BROKER_TIMEOUT_MODAL_CLOSED: {
      draft.shouldShowBrokerTimeoutModal = false
      break
    }
    case Actions.LAYOUT_APPLIED: {
      draft.layout = payload.layout
      break
    }
    case Actions.SAVE_DIALOG_OPEN_CLICKED: {
      draft.isSaveRequsted = true
      break
    }
    case Actions.APPLICATION_VALIDATED: {
      draft.isSaveRequsted = false
      break
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
